export default "__VITE_ASSET__BVTWY5RN__"